import * as React from 'react';

export const PremiumIcon = () => {
  return (
    <svg width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4835 20.8219c-.4738-.2809-1.14709-.4777-1.86188-.1714-1.06901.4582-3.35428 1.209-4.36329 1.5272l-1.79986-1.7999c1.47261-2.8725 5.24685-8.792 8.56293-9.4902 1.8392-.3871 3.0307-.0485 3.7599.4867.8364-.9707 1.82-2.03076 2.9757-3.18643 8.7969-8.796797 15.2724-5.21726 15.2724-5.21726s3.238 6.13387-5.4555 15.03469c-1.1459 1.1459-2.1979 2.1227-3.1618 2.9545.6679.6845 1.1802 1.9424.7356 4.054-.6981 3.3161-6.6176 7.0904-9.4901 8.563l-1.7999-1.7999c.3182-1.009 1.069-3.2942 1.5272-4.3633.3311-.7726.0743-1.4969-.2411-1.9729-.059-.0261-.0871-.0451-.0871-.0451l-4.5732-4.5737Zm-.216 10.6944C8.67039 33.1134 2.25 33.75 2.25 33.75s.63659-6.4204 2.23374-8.0175c1.59715-1.5972 4.18665-1.5972 5.78376 0 1.5972 1.5971 1.5972 4.1866 0 5.7838Zm11.7168-18.0735c1.1986 1.1986 3.142 1.1986 4.3406 0 1.1986-1.1986 1.1986-3.142 0-4.34064-1.1986-1.19862-3.142-1.19862-4.3406 0-1.1986 1.19864-1.1986 3.14204 0 4.34064Z"
        fill="url(#premium-icon)"
      />
      <defs>
        <linearGradient id="premium-icon" x1="17.9348" y1="2.25" x2="17.9348" y2="33.75" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF7E00" stopOpacity=".58" />
          <stop offset="1" stopColor="#FF7E00" />
        </linearGradient>
      </defs>
    </svg>
  );
};
